import styles from "./ErrorCountBadge.module.css";

export const ErrorCountBadge = ({ errorCount }: { errorCount: number }) => {
  if (errorCount === 0)
    return <div className={styles.empty}>&nbsp;</div>;

  return <span className={styles.badge}>{`${errorCount}`}</span>
}